module.exports = __webpack_public_path__ + "static/media/MoveDown.b28c1836.svg";